/** Client helpers for My Survey. Progress shown on the page is counted from local answers. */

export function isQuestionAnswered(question, answer) {
  if (!question || !answer) return false;
  const value = answer.value;
  if (question.type === 'multi') return Array.isArray(value) && value.length > 0;
  if (question.type === 'choice') return typeof value === 'string' && value.length > 0;
  return typeof value === 'string' && value.trim().length > 0;
}

export function moduleStats(module, answers) {
  const questions = (module?.subsections || [])
    .flatMap((section) => section.questions || [])
    .filter((question) => !question.hidden);
  const answered = questions.filter((question) => isQuestionAnswered(question, answers?.[question.id])).length;
  const total = questions.length;
  return {
    answered,
    total,
    percent: total ? Math.round((answered / total) * 100) : 0,
  };
}

export function selectedFillInOption(question, answer) {
  if (!question?.options || !answer) return null;
  if (question.type === 'choice') {
    return question.options.find((option) => option.fillIn && option.key === answer.value) || null;
  }
  if (question.type === 'multi') {
    const values = Array.isArray(answer.value) ? answer.value : [];
    return question.options.find((option) => option.fillIn && values.includes(option.key)) || null;
  }
  return null;
}
